import React from "react";
import { Typography } from "@mui/material";
import EntityReferenceComponent from "../../entitiesReferences/EntityReferenceComponent";
import { EntityReferenceLinkMode } from "../../entitiesReferences/InternalEntityLink";
import { RichTextEditor } from "../../field/richTextEditor/RichTextEditor";
import { VersionReference } from "../../../types/version";

interface ViewVersionReferenceFieldProps {
  value?: VersionReference | null;
  placeholder?: string;
  linkMode?: EntityReferenceLinkMode;
}

const ViewVersionReferenceField: React.FC<ViewVersionReferenceFieldProps> = ({
  value,
  placeholder = "N/A",
  linkMode = "view",
}) => {
  if (!value) {
    return <Typography variant="body1">{placeholder}</Typography>;
  }

  if (value.version_exist) {
    if (value.version) {
      return <EntityReferenceComponent entity={value.version} linkMode={linkMode} />;
    }

    return (
      <Typography variant="body1">
        {value.version_id ? value.version_id : placeholder}
      </Typography>
    );
  }

  if (value.version_notes) {
    return (
      <RichTextEditor
        value={value.version_notes}
        readOnly
        fullWidth
        placeholder={placeholder}
      />
    );
  }

  return <Typography variant="body1">{placeholder}</Typography>;
};

export default ViewVersionReferenceField;
